import { UploadTestIds } from '@/enums/uploadTestIds.enum';
import { RefObject } from 'react';

export const FileInputs = ({
  fileInputProps,
  fileInputReference,
  folderInputReference,
}: {
  fileInputProps: React.InputHTMLAttributes<HTMLInputElement>;
  fileInputReference: RefObject<HTMLInputElement | null>;
  folderInputReference: RefObject<HTMLInputElement | null>;
}) => {
  return (
    <>
      <input
        {...fileInputProps}
        key={'file-inputs-files'}
        data-testid={UploadTestIds.FileInput}
        ref={fileInputReference}
        style={{ display: 'none' }}
      />
      <input
        hidden
        {...fileInputProps}
        ref={folderInputReference}
        key={'file-inputs-folder'}
        data-testid={UploadTestIds.FolderInput}
        // @ts-expect-error - webkitdirectory is valid attribute but not in the type definitions
        webkitdirectory=''
      />
    </>
  );
};
